import React, { useState, useEffect } from "react";
import { Button, Card, Col, Row, Input } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import "./App.css"; // Ensure your hover effect styles are here
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const Screens = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMetricsClick = () => {
    window.location.href = "https://www.stockbuzz.ai/Metrics";
  };

  const handleCardClick = (message) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("question", message);
    navigate(`/?${searchParams.toString()}`);
  };

  const handleIndustryCardClick = (message) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("question", `Analyze Top Companies in ${message} Sector`);
    navigate(`/?${searchParams.toString()}`);
  };

  const SectionWithScroll = ({ title, items }) => {
    const scrollRef = React.useRef(null);
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 600);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth < 600);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const scroll = (dir) => {
      if (scrollRef.current) {
        scrollRef.current.scrollBy({
          left: dir === "left" ? -300 : 300,
          behavior: "smooth",
        });
      }
    };

    const arrowStyle = {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 10,
      fontSize: 20,
      backgroundColor: "#fff",
      borderRadius: "50%",
      boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
      padding: "4px",
      cursor: "pointer",
    };

    return (
      <Card style={{ marginBottom: "5%", backgroundColor: "whitesmoke" }}>
        <Card.Meta
          title={title}
          description={`Screens based on ${title.toLowerCase()}`}
        />

        <div style={{ position: "relative", marginTop: "16px" }}>
          {/* Arrows */}
          <LeftOutlined
            onClick={() => scroll("left")}
            style={{ ...arrowStyle, left: 8 }}
          />
          <RightOutlined
            onClick={() => scroll("right")}
            style={{ ...arrowStyle, right: 8 }}
          />

          {/* Scrollable Cards */}
          <div
            ref={scrollRef}
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 16,
              overflowX: "auto",
              scrollBehavior: "smooth",
              padding: isMobile ? "0 16px" : "0 40px",
            }}
          >
            {items.map((item, index) => (
              <Card
                key={index}
                onClick={() => handleCardClick(item.description)}
                style={{
                  flex: "0 0 auto",
                  width: isMobile ? "100vw" : "300px", // full width for mobile, fixed for desktop
                  maxWidth: isMobile ? "calc(100vw - 64px)" : "300px",
                  boxSizing: "border-box",
                  borderRadius: "12px",
                  cursor: "pointer",
                }}
                bodyStyle={{
                  padding: 16,
                  whiteSpace: "normal",
                  overflowWrap: "break-word",
                }}
              >
                <Card.Meta
                  title={
                    <div style={{ fontWeight: 600, fontSize: "1rem" }}>
                      {item.title}
                    </div>
                  }
                  description={
                    <div style={{ fontSize: "0.9rem", color: "#555" }}>
                      {item.description}
                    </div>
                  }
                />
              </Card>
            ))}
          </div>
        </div>
      </Card>
    );
  };

  const IndustryButtons = ({ industries, handleIndustryCardClick }) => {
    return (
      <Card
        style={{
          width: isMobile ? "100%" : "33%",
          marginLeft: isMobile ? "0%" : "2%",
          padding: "1rem",
          borderRadius: "10px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          marginTop: isMobile ? "5%" : "0%",
        }}
      >
        <h2>Browse Sectors</h2>
        <div style={{ marginTop: "5%", display: "flex", flexWrap: "wrap" }}>
          {industries.map((industry, index) => (
            <Button
              key={index}
              style={{
                margin: "2%",
                backgroundColor: "whitesmoke",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                padding: "0.4rem 0.4rem",
                transition: "all 0.3s",
                fontSize: "0.8rem",
              }}
              onClick={() => handleIndustryCardClick(industry)}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#e6f7ff")}
              onMouseLeave={(e) =>
                (e.target.style.backgroundColor = "whitesmoke")
              }
            >
              {industry}
            </Button>
          ))}
        </div>
      </Card>
    );
  };
  const industries = [
    "AI Solutions",
    "Renewable Energy",
    "Wealth Management",
    "Financial Services",
    "E-commerce",
    "Real Estate",
    "Data Centers",
    "Natural Gas",
    "Cybersecurity",
    "Cloud Services",
    "Digital Marketing",
    "Biopharmaceuticals",
    "Insurance Services",
    "Retail Banking",
    "Healthcare",
    "Industrial Automation",
    "Mobile Banking",
    "Asset Management",
    "Payment Processing",
    "Real Estate Investment",
    "Logistics",
    "Cloud Solutions",
    "Consumer Finance",
    "Infrastructure",
    "Energy Transition",
    "Energy Management",
    "Supply Chain",
    "Investment Banking",
    "Life Sciences",
    "Digital Health",
    "Commercial Banking",
    "Drug Development",
    "Artificial Intelligence",
    "Automation",
    "Sustainability Initiatives",
    "Machine Learning",
    "Private Equity",
    "Blockchain Technology",
    "Digital Advertising",
    "Direct-to-Consumer",
    "Pharmaceuticals",
    "Retail Stores",
    "Commercial Real Estate",
    "Insurance Products",
    "Biotechnology",
    "Cloud Computing",
    "Medical Devices",
    "Energy Storage",
    "Software Solutions",
    "Gene Therapy",
    "Consumer Electronics",
    "Carbon Capture",
    "Construction Materials",
    "Digital Transformation",
    "E-mobility",
    "Aerospace",
    "Investment Advisory",
    "Customer Experience",
    "Banking Services",
    "Subscription Services",
    "Healthcare Innovation",
    "Smart Manufacturing",
  ];

  return (
    <div
      style={{
        display: isMobile ? "block" : "flex",
        padding: "2% 2% 10% 2%",
        marginTop: isMobile ? "20%" : "5%",
        marginBottom: isMobile ? "15%" : "0%",
      }}
    >
      <div style={{ width: isMobile ? "100%" : "100%" }}>
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>Stock Screens</h2>
          <Button
            style={{ backgroundColor: "whitesmoke", fontSize: "medium" }}
            onClick={handleMetricsClick}
          >
            Show all Metrics
          </Button>
        </div>

        <SectionWithScroll
          title="High Conviction Fundamentals"
          items={[
            {
              title: "Strong Free Cash Flow + Low Debt",
              description:
                "Companies with high free cash flow and debt-to-equity ratio under 0.5",
            },
            {
              title: "High ROIC + Undervalued",
              description:
                "Efficient capital users with ROIC > 15% and low P/E or P/B multiples",
            },
            {
              title: "Consistent Multi-Year EPS Growth",
              description:
                "Stocks growing EPS for at least 3 consecutive years",
            },
          ]}
        />
        <SectionWithScroll
          title="Earnings Trends"
          items={[
            {
              title: "Earnings Beats + Profitability",
              description:
                "Stocks that beat EPS estimates and show strong net margins",
            },
            {
              title: "Earnings Announced Last Month",
              description:
                "Recently reported companies — filterable by sector or metric",
            },
            {
              title: "Analyst Target Revisions",
              description:
                "Companies where analysts raised future price targets",
            },
          ]}
        />
        <SectionWithScroll
          title="AI & Tech Sector Screens"
          items={[
            {
              title: "AI Stocks with High ROE",
              description:
                "Tech companies in AI-related sectors with strong return on equity > 20%",
            },

            {
              title: "US-Based High Growth Chips",
              description:
                "US semiconductor and IC design companies with strong revenue growth",
            },

            {
              title: "AI Infrastructure Leaders",
              description:
                "Chipmakers and cloud compute firms in sectors like semiconductors and IC design",
            },
          ]}
        />
        <SectionWithScroll
          title="Sector + Macro Trends"
          items={[
            {
              title: "News-Driven Sector Picks",
              description:
                "Which US stocks are reacting to headlines around trade wars, reshoring, and regulation?",
            },
            {
              title: "AI & Chip Supply Winners",
              description:
                "Top AI infrastructure stocks including semiconductors, IC design, and cloud enablers",
            },
            {
              title: "Energy Resurgence",
              description:
                "Oil, gas, and renewable energy names seeing bullish momentum from global demand shifts",
            },
            {
              title: "Inflation-Proof Stocks",
              description:
                "Companies in pricing-power sectors like energy, food, and healthcare that defend margins",
            },
            {
              title: "Crash-Resilient Ideas",
              description:
                "Stocks with stable earnings and low beta that tend to hold during housing or market crashes",
            },
            {
              title: "EV & Battery Tech Challengers",
              description:
                "Tesla competitors in battery, charging, and electric mobility across US and Asia",
            },
          ]}
        />
        <SectionWithScroll
          title="Dividends & Income Picks"
          items={[
            {
              title: "Dividend Kings",
              description:
                "Top dividend yielders with positive net income and sustainable payout ratios",
            },
            {
              title: "High Dividend, Low Payout",
              description:
                "Income stocks with high dividend yield and payout ratio below 60%",
            },
            {
              title: "Steady Dividend Growers",
              description:
                "Companies with a track record of increasing dividend per share",
            },
            {
              title: "Low Volatility Dividend Stocks",
              description:
                "High dividend payers with beta under 1 and low debt",
            },
          ]}
        />
      </div>
      {/* 
      <IndustryButtons
        industries={industries}
        handleIndustryCardClick={handleIndustryCardClick}
      /> */}
    </div>
  );
};

export default Screens;
